import * as actions from './materiais.action';
import inicialState from './materiais.state';

const materiaisReducer = (state = inicialState, action) => {
  switch (action.type) {
   
    case actions.MATERIAIS_DESCARTADOS_ATUALIZAR_DATA_INI:
      return {
        ...state,
        dataInicio: action.payload.dataInicio,
      };
    case actions.MATERIAIS_DESCARTADOS_ATUALIZAR_DATA_FIM:
      return {
        ...state,
        dataFim: action.payload.dataFim,
      };
    
    case actions.MATERIAIS_DESCARTADOS_ATUALIZAR_FILTRO_VALUE:
      return {
        ...state,
        filtroValue: action.payload.filtroValue,
      };
   
    case actions.MATERIAIS_DESCARTADOS_ATUALIZAR_LISTA:
      return {
        ...state,
        lista: action.payload.lista,
      };
   
    case actions.MATERIAIS_DESCARTADOS_ATUALIZAR_PAGE:
      return {
        ...state,
        page: action.payload.page,
      };
   
    case actions.MATERIAIS_DESCARTADOS_ATUALIZAR_IMPRIMIR:
      return {
        ...state,
        imprimir: action.payload.imprimir,
      };
   
    default:
      return state;
  }
};

export default materiaisReducer;



// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/materiais/store/materiais.reducer.js